<template>
    <div>
        <v-card elevation="0">
            <v-card-title>
                <v-icon>mdi-download</v-icon>&nbsp;Download Latest File
            </v-card-title>
            <v-card-text>
                Under construction
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
        }
    },
    methods: {
    }
}
</script>